<template>
  <footer class="home-footer">
    <div class="brand">
      <p class="name">Rainbow Manager</p>
      <p class="tag">{{ t('welcomeSubText') }}</p>
    </div>
    <nav>
      <router-link to="/consultation">{{ t('consultation') }}</router-link>
      <router-link to="/FAQ">{{ t('FAQ') }}</router-link>
      <router-link to="/contacts">{{ t('contacts') }}</router-link>
      <router-link to="/signUp">{{ t('signUp') }}</router-link>
      <a :href="privacyUrl" target="_blank" rel="noopener">{{ t('privacyPolicy') }}</a>
      <a :href="termsUrl" target="_blank" rel="noopener">{{ t('termsOfService') }}</a>
      <router-link to="/account/delete">{{ t('accountDeleteTitle') }}</router-link>
    </nav>
    <p class="mark">© {{ years }} Rainbow Manager</p>
  </footer>
</template>
<script lang="ts">
import { computed, defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';
import { privacyPolicyUrl, termsOfServiceUrl } from '@/helpers/privacy-url.helper';

const SITE_SINCE = 2025;

export default defineComponent({
  setup() {
    const { t } = useI18n();
    const store = useStore();
    const language = computed(() => store.getters['language/language'] as string);
    const privacyUrl = computed(() => privacyPolicyUrl(language.value));
    const termsUrl = computed(() => termsOfServiceUrl(language.value));
    const nowYear: number = new Date().getFullYear();
    const years: string = nowYear > SITE_SINCE ? `${SITE_SINCE}–${nowYear}` : String(SITE_SINCE);

    return {
      t,
      privacyUrl,
      termsUrl,
      years,
    };
  },
});
</script>
<style scoped lang="scss">
.home-footer {
  display: grid;
  grid-template-columns: minmax(0, 1.1fr) minmax(0, 1fr);
  gap: 18px 48px;
  margin-top: 24px;
  padding: 28px 0 12px;
  border-top: 1px solid rgba(246, 243, 238, 0.1);
  text-align: left;
}

.name {
  margin: 0 0 8px;
  font-size: 15px;
  font-weight: 600;
  letter-spacing: -0.02em;
}

.tag {
  margin: 0;
  max-width: 42ch;
  font-size: 13px;
  line-height: 1.5;
  color: rgba(246, 243, 238, 0.62);
}

nav {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 18px;
  align-content: start;
}

a {
  font-size: 13px;
  color: rgba(246, 243, 238, 0.72);
}

a:hover {
  color: #f6f3ee;
}

.mark {
  grid-column: 1 / -1;
  margin: 8px 0 0;
  font-size: 12px;
  color: rgba(246, 243, 238, 0.48);
}

@media (max-width: 700px) {
  .home-footer {
    grid-template-columns: 1fr;
  }
}
</style>
